<template>
  <Layout>
    <PageHeader :title="title" :breadcrumbs="breadcrumbs"/>
    <div class="row">
      <div class="col-lg-12">
        <h1>{{ $t("departments.overview.title") }}</h1>
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <b-row>
                <div class="col col-12 m-2">
                  <router-link tag="a" to="/departments/create" class=" col-lg-10 justify-content-end">
                    <button
                    type="button"
                    class="btn btn-success m-3">
                    {{ $t("departments.overview.create-new-department-button") }}
                    </button>
                  </router-link>
                </div>
              </b-row>

              <b-row>
                <b-col lg="12">
                  <b-form-group
                    :label="$t('search')"
                    label-cols="3"
                    label-align="right"
                    label-size="sm"
                    label-for="filter-input"
                    class="mb-0"
                  >
                    <b-input-group size="sm">
                      <b-form-input
                        v-model="filter"
                        type="search"
                        id="filter-input"
                        placeholder="..."
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">
                          {{ $t("clear-search") }}
                          </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-table
                striped
                hover
                :items="allDepartments"
                :fields="fields"
                :filter="filter">
                <template #cell(actions)="department">
                  <ul class="list-inline font-size-20 contact-links mb-0">
                    <li class="list-inline-item px-2">
                      <a
                      v-b-tooltip.hover
                      :title= "$t('departments.overview.form.actions.modify')"
                      @click="redirectToDepartmentEditById(department.item.id)"
                      class="department--function department--function__modify-department"
                      >
                        <i class="bx bx-pencil" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li class="list-inline-item px-2">
                      <a
                        v-b-tooltip.hover
                        :title= "$t('departments.overview.form.actions.delete')"
                        @click="deleteGivenDepartment(department.item)"
                        class="department--function department--function__delete-department"
                        >
                        <i class="bx bx-trash"></i>
                      </a>
                    </li>
                  </ul>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import i18n from "@/i18n";
import router from "@/router/index";
import Swal from "sweetalert2";
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { toastrService } from "@/helpers/services/notification/toastrService";
import { userService } from "@/helpers/services/user/userService";


export default {
  page: {
    title: i18n.t("departments.overview.header"),
    meta: [{ name: "description", content: appConfig.description }]
  },
  props: ["toastrMessage", "toastrType"],
  components: { Layout, PageHeader },
  data() {
    return {
      title: "",
      allDepartments: [],
      breadcrumbs: [
        {text: i18n.t('departments.overview.header'), active: true},
      ],
      fields: [
        { key: "title", label: i18n.t("departments.overview.form.name") },
        { key: "description", label: i18n.t("departments.overview.form.description") },
        { key: "parentTitle", label: i18n.t("departments.overview.form.parent-department") },
        { key: "talentCount", label: i18n.t("departments.overview.form.user-amount") },
        { key: "actions", label: i18n.t("departments.overview.form.actions.text") },
      ],
      filter: null,
    };
  },
  methods: {
    deleteGivenDepartment(department) {
      Swal.fire({
        title: i18n.t("departments.overview.delete-department-modal.title"),
        html: i18n.t(
          "departments.overview.delete-department-modal.message",
          {departmentTitle: department.title}
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#556ee6",
        cancelButtonColor: "rgba(221, 51, 51, 0.7)",
        confirmButtonText: `<i class='fa fa-trash' aria-hidden='true'></i> ${i18n.t("yes")}`,
        cancelButtonText: `${i18n.t("no")}`

      }).then((result) => {
        if (result.value) {
          userService.deleteDepartment(department);
        }
      });
    },
    modifyDepartmentsUsers() {
    },
    redirectToDepartmentEditById(departmentId) {
      router.push({ path: `/departments/${departmentId}` });
    },
    showToastrMessage(toastrType, toastrMessage) {
      switch (toastrType) {
        case toastrService.ERROR_TYPE:
          toastrService.showError(toastrMessage);
          break;
        case toastrService.SUCCESS_TYPE:
          toastrService.showSuccess(toastrMessage);
          break;
        default:
          break;
      }
    }
  },
  created() {
    userService.fetchDepartments()
      .then(d => this.allDepartments = d);
    this.showToastrMessage(this.toastrType, this.toastrMessage);
  },
};
</script>
